"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.notificationIconKeys = exports.notificationIconSizes = exports.notificationIconColors = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

var NotificationsIcons = _interopRequireWildcard(require("../../../assets/icons/notification/icons"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {},
    red: {
      "& path": {
        fill: theme.palette.primary.main
      }
    },
    white: {
      "& path": {
        fill: theme.palette.common.white
      }
    },
    midGrey: {
      "& path": {
        fill: theme.palette.grey[500]
      }
    },
    green: {
      "& path": {
        fill: theme.palette.success.main
      }
    },
    small: {
      fontSize: 18,
      width: 18,
      height: 18
    },
    default: {
      fontSize: 24,
      width: 24,
      height: 24
    },
    large: {
      fontSize: 32,
      width: 32,
      height: 32
    }
  };
});
/**
 * ** System icons are used to help wayfinding to our products and services and to aid navigation in
 * Vodafone’s digital channels. The design is simple and modern. Each icon is reduced to its
 * minimal form and every metaphor distilled to its essence. Although the optimal size is 24 px, we
 * do accept that icons may vary in size depending on font sizes, so acceptable sizes range from
 * around 18 - 32px (but sometimes smaller depending on the icon). The line weight should always
 * be 1 px without exception. **
 *
 * There are 3 colors: Red, White, Grey
 *
 * There are 5 sizes: Small, Default, Large, XLarge, XXLarge
 *
 */

var NotificationIcon = function NotificationIcon(_ref) {
  var _classNames;

  var color = _ref.color,
      size = _ref.size,
      icon = _ref.icon;
  var styles = useStyles();
  return icon && /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
    title: icon,
    className: (0, _classnames.default)((_classNames = {}, _defineProperty(_classNames, styles.root, true), _defineProperty(_classNames, styles[color], true), _defineProperty(_classNames, styles[size], true), _classNames)),
    component: NotificationsIcons[icon],
    viewBox: "0 0 24 24"
  });
};

NotificationIcon.propTypes = {
  /** The SystemIcon icon key */
  icon: _propTypes.default.string.isRequired,

  /** The color variant of the icon */
  color: _propTypes.default.oneOf(["red", "white", "midGrey", "green"]),

  /** The Size variant of the icon */
  size: _propTypes.default.oneOf(["small", "default", "large", "xLarge", "xxLarge"])
};
NotificationIcon.defaultProps = {
  color: "white",
  size: "default"
};
var notificationIconColors = ["red", "white", "midGrey", "green"];
exports.notificationIconColors = notificationIconColors;
var notificationIconSizes = ['small', 'default', 'large'];
exports.notificationIconSizes = notificationIconSizes;
var notificationIconKeys = Object.keys(NotificationsIcons);
exports.notificationIconKeys = notificationIconKeys;
var _default = NotificationIcon;
exports.default = _default;